const BasedURL = process.env.REACT_APP_API_URL || "http://localhost:3001/api/v1"
// Remote: const BasedURL = "http://157.230.222.47:3001/api/v1"
   

export {BasedURL}